/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlaceDetailsResponse } from '../models/PlaceDetailsResponse';
import type { PlaceRefreshResponse } from '../models/PlaceRefreshResponse';
import type { PlaceSearchRequest } from '../models/PlaceSearchRequest';
import type { PlaceSearchResponse } from '../models/PlaceSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GooglePlacesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Text Searchでplace_id候補を検索します。
     * Text Search APIでplace_id候補を検索.
     * @returns PlaceSearchResponse Successful Response
     * @throws ApiError
     */
    public searchPlaces({
        requestBody,
    }: {
        requestBody: PlaceSearchRequest,
    }): CancelablePromise<PlaceSearchResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/google/places/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Place Detailsで詳細情報を取得します。
     * Place Details APIで詳細情報を取得.
     * @returns PlaceDetailsResponse Successful Response
     * @throws ApiError
     */
    public getPlaceDetails({
        placeId,
        skipCache = false,
        fields,
    }: {
        placeId: string,
        /**
         * キャッシュを無視してGoogle APIを直接呼び出す
         */
        skipCache?: boolean,
        /**
         * 取得するフィールドグループ（カンマ区切り）
         */
        fields?: (string | null),
    }): CancelablePromise<PlaceDetailsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/google/places/{place_id}',
            path: {
                'place_id': placeId,
            },
            query: {
                'skip_cache': skipCache,
                'fields': fields,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * place_idの洗い替えを実行します。
     * place_idの洗い替え（有効性確認）.
     * @returns PlaceRefreshResponse Successful Response
     * @throws ApiError
     */
    public refreshPlaceId({
        placeId,
    }: {
        placeId: string,
    }): CancelablePromise<PlaceRefreshResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/google/places/{place_id}/refresh',
            path: {
                'place_id': placeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
